import Pusher from 'pusher-js'

const EVENT_X_AUTH = 'x_auth'
const EVENT_DISCORD_AUTH = 'discord_auth'
const PUSHER_CLUSTER = 'eu'

class PusherService {
  constructor() {
    if (PusherService.instance) return PusherService.instance

    this.pusherInstance = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
      cluster: PUSHER_CLUSTER
    })

    // Store active channels and callbacks
    this.channels = {} // { channelName: Pusher.Channel }
    this.bindings = {} // { channelName: { eventName: callback } }

    PusherService.instance = this
  }

  static getInstance() {
    if (!PusherService.instance) {
      PusherService.instance = new PusherService()
    }
    return PusherService.instance
  }

  subscribe(channelName, eventName, callback) {
    if (!channelName || !eventName || !callback) return

    // Subscribe to channel if not already
    if (!this.channels[channelName]) {
      this.channels[channelName] = this.pusherInstance.subscribe(channelName)
      this.bindings[channelName] = {}
    }

    // Bind event
    this.channels[channelName].bind(eventName, callback)
    this.bindings[channelName][eventName] = callback
  }

  unsubscribe(channelName) {
    if (!channelName || !this.channels[channelName]) return

    // Unbind all events for this channel
    const channel = this.channels[channelName]
    const eventBindings = this.bindings[channelName] || {}

    Object.entries(eventBindings).forEach(([eventName, cb]) => {
      channel.unbind(eventName, cb)
    })

    // Unsubscribe and cleanup
    this.pusherInstance.unsubscribe(channelName)
    delete this.channels[channelName]
    delete this.bindings[channelName]
  }

  unsubscribeAll() {
    Object.keys(this.channels).forEach((channelName) => {
      this.unsubscribe(channelName)
    })
  }
}

export { EVENT_X_AUTH, EVENT_DISCORD_AUTH, PusherService }
